<template>
  <b-tab title="Extrato PJ" @click="onExtractTabClick()">
    <b-col lg="6" class="my-1">
      <b-row>
        <b-form-radio-group v-model="userRadioExtractSelected" buttons>
          <b-form-radio value="cnpj" v-b-tooltip.hover title="CNPJ">CNPJ</b-form-radio>
          <b-form-radio value="cod" v-b-tooltip.hover title="Código">Código</b-form-radio>
          <b-form-radio value="name" v-b-tooltip.hover title="Nome">Nome</b-form-radio>
        </b-form-radio-group>
        <b-input-group size="sm" style="{padding-top: 10px; margin-top: 10px;}">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="filterUserExtractText" v-on:keyup.enter="onUserExtractSearchClick()"
            type="search" placeholder="Buscar..."></b-form-input>
        </b-input-group>
      </b-row>
    </b-col>
    <b-table striped :fields="corporateFields" :current-page="currentCorporatePage" :items="corporates"
      :per-page="0" stacked="md">
      <template v-slot:cell(info)="row">
        <b-row>
          <b-button class="item-table" @click="onInfoClick(row.item, row.index, $event.target)">+</b-button>
        </b-row>
      </template>
    </b-table>
    <b-col sm="7" md="6" class="my-1">
      <b-pagination @input="updateCorporatePage()" v-model="currentCorporatePage" :total-rows="totalCorporateRows"
        :per-page="perCorporatePage" align="fill" size="sm" class="my-0"></b-pagination>
    </b-col>

    <b-modal id="modal-prevent-closing" ref="corporateModal" ok-title="Ok" cancel-variant="transparent"
      :title="corporateModalTitle" @hidden="resetCorporateModal" @ok="handleCorporateModalOk" size="xl">
      <b-form v-on:submit.prevent>

        <b-row>
          <b-col>
            <b-form-group label="Data inicial" label-for="date-input">
              <b-form-datepicker id="example-datepicker" v-model="selectedBeginDate" v-on:input="onDateChange()"
                v-bind="labels[locale] || {}" reset-button :locale="locale"></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Data final" label-for="date-input">
              <b-form-datepicker id="example-datepicker2" v-model="selectedFinalDate"
                v-on:input="onDateChange()" v-bind="labels[locale] || {}" reset-button
                :locale="locale"></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col>
            <h5 style="font-size:10">Total <b-badge class="badge">{{statementTotal}}</b-badge></h5>
            <download-csv @export-started="generateDataToExport()" ref="csvExporter"
              :name="statementCsvTitle" />
          </b-col>
          <b-col>
            <div>
              <b-form-radio-group v-model="selected" buttons>
                <b-form-radio value="user" v-b-tooltip.hover title="Usuário Responsável">Usuário</b-form-radio>
                <b-form-radio value="cod" v-b-tooltip.hover title="Código">Código</b-form-radio>
                <b-form-radio value="description" v-b-tooltip.hover
                  title="Descrição da auditoria">Descrição</b-form-radio>
                <b-form-radio value="type" v-b-tooltip.hover title="Tipo da transação">Tipo</b-form-radio>
                <b-form-radio value="api" v-b-tooltip.hover title="Nome do token">Api</b-form-radio>
                <b-form-radio value="duration" v-b-tooltip.hover
                  title="Duração da transação">Duração</b-form-radio>
              </b-form-radio-group>
              <div>
                <b-input-group size="sm" style="{padding-top: 10px; margin-top: 10px;}">
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input v-model="filterText" v-on:keyup.enter="onStatementSearchClick()" type="search"
                    placeholder="Buscar..."></b-form-input>
                </b-input-group>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-table responsive striped :fields="statementFields" :items="statements" @sort-changed="sortChanged"
            :per-page="0" :current-page="currentStatementPage"
            style="{ max-height: 300px !important; height: 300px !important; overflow-y: scroll}">
          </b-table>
          <b-row>
            <b-col class="my-3">
              <b-pagination @input="updatePage()" v-model="currentStatementPage"
                :total-rows="totalStatementRows" :per-page="perStatementPage" align="fill" size="sm"
                class="my-0"></b-pagination>
            </b-col>
            <b-col class="my-3">
              <b-form-select id="per-page-select" v-model="perStatementPage" :options="pageOptions"
                @input="updatePage()"></b-form-select>
            </b-col>
          </b-row>
        </b-row>

      </b-form>
    </b-modal>
  </b-tab>
</template>

<script>
  import { userService } from '../../services/user_service';
  import { formatingSecondToDate } from '../../helpers/server';
  import { storeService } from '../../services/store.service';
  import JsonCSV from '../Export/JsonCSV.vue';
  import moment from 'moment';

  export default {
    components: {
      'download-csv': JsonCSV
    },
    data () {
      return {
        tabType: '',
        locale: 'pt-BR',
        perCorporatePage: 10,
        currentStatementPage: 1,
        selected: 'user',
        perStatementPage: 10,
        currentCorporatePage: 1,
        userRadioExtractSelected: 'name',
        filterUserExtractText: '',
        adminInfoLoaded: true,
        isLoading: false,
        corporates: [],
        filterText: '',
        statements: [],
        selectedBeginDate: null,
        selectedFinalDate: null,
        totalCorporateRows: 1,
        statementTotal: 0,
        pageOptions: [5, 10, 15, { value: 100, text: 'Mostrar 100' }],
        totalStatementRows: 0,
        corporateId: 0,
        corporateName: '',
        statementCsvTitle: '',
        accountId: 0,
        accountLogin: '',
        corporateModalTitle: 'Extrato',
        statementModalLoaded: false,
        labels: {
          'pt-BR': {
            labelPrevDecade: 'Década anterior',
            labelPrevYear: 'Ano passado',
            labelPrevMonth: 'Mês passado',
            labelCurrentMonth: 'Mês atual',
            labelNextMonth: 'Próximo mês',
            labelNextYear: 'Próximo ano',
            labelNextDecade: 'Próxima década',
            labelToday: 'Hoje',
            labelSelected: 'Data selecionada',
            labelNoDateSelected: 'Selecione uma data',
            labelCalendar: 'Calendário',
            labelNav: 'Navegação do calendário',
            labelHelp: 'Navegue pelo calendário com as teclas de seta'
          }
        },
        corporateFields: [
          { key: 'corporateId', label: 'Cód', sortable: true },
          { key: 'name', label: 'Nome', sortable: true },
          { key: 'master', label: 'Master', sortable: true, thStyle: { width: '220px' } },
          { key: 'document', label: 'CNPJ', sortable: true, thStyle: { width: '220px' } },
          {
            key: 'created',
            label: 'Data',
            sortable: true,
            formatter: (value, key, item) => {
              return moment.unix(value).format('DD/MM/YYYY');
            },
            thStyle: { width: '180px' }
          },
          {
            key: 'credits.credits',
            label: 'Créditos disponiveis',
            sortable: false,
            formatter: (value, key, item) => {
              return formatingSecondToDate(value);
            },
            thStyle: { width: '150px' }
          },
          { key: 'info', label: 'Info', sortable: false, thStyle: { width: '150px' } }
        ],
        statementFields: [
          { key: 'login', label: 'Usuário' },
          { key: 'statementId', label: 'Cód', sortable: true },
          { key: 'observation', label: 'Descrição', sortable: true, thStyle: { width: '370px' } },
          {
            key: 'transactionType',
            label: 'Tipo',
            sortable: true,
            formatter: (value, key, item) => {
              return value === 'D' ? 'Débito' : 'Crédito';
            },
            thStyle: { width: '110px' }
          },
          {
            key: 'created',
            label: 'Data',
            sortable: true,
            formatter: (value, key, item) => {
              return moment.unix(value).format('DD/MM/YYYY');
            },
            thStyle: { width: '120px' }
          },
          {
            key: 'tokenName',
            label: 'API',
            sortable: false,
            thStyle: { width: '150px' }
          },
          {
            key: 'mediaLength',
            label: 'Duração',
            sortable: false,
            formatter: (value, key, item) => {
              return new Date(value * 1000).toISOString().substring(11, 19);
            },
            thStyle: { width: '110px' }
          }
        ]
      };
    },
    watch: {
      filterText (newValue) {
        this.filterText = newValue.replace(/[^\p{L}\p{N}\s()]/gu, '');
      }
    },
    methods: {
      async onExtractTabClick () {
        this.tabType = 'corp';
        await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage), adminTab: 'extratoPJ' });
      },
      async onUserExtractSearchClick () {
        if (this.adminInfoLoaded) {
          if (this.userRadioExtractSelected === 'cnpj' && this.filterUserExtractText.length > 2) {
            await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage), cnpj: this.filterUserExtractText.trim() });
          } else if (this.userRadioExtractSelected === 'cod') {
            await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage), corporateId: this.filterUserExtractText.trim() });
          } else if (this.userRadioExtractSelected === 'name' && this.filterUserExtractText.length > 1) {
            await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage), name: this.filterUserExtractText.trim() });
          } else {
            await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage) });
          }
        }
      },
      async loadCorporateInfo (params) {
        this.isLoading = true;
        const result = await userService.corporateInfo(params);
        if (result === 'Timeout') {
          this.isLoading = false;
          this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
          return;
        }
        this.isLoading = false;
        if (result && result.length > 0) {
          this.corporates = [];
          this.corporates = result[0].elements;
          this.pageInfo = result[0].pageInfo;
          this.totalCorporateRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
          console.log(this.corporates);
          console.log(this.pageInfo);
          console.log(this.totalCorporateRows);
          console.log(this.perCorporatePage);
          console.log(this.currentCorporatePage);
        }
      },
      async onInfoClick (item, index, target) {
        this.pageInfo = null;
        this.totalStatementRows = null;
        this.statementTotal = null;
        if (item.corporateId) {
          this.corporateId = item.corporateId;
          this.corporateName = item.name;
          this.statementCsvTitle = this.corporateName + '.csv';
        } else {
          this.corporateId = null;
          this.accountId = item.accountId;
          this.accountLogin = item.login;
        }
        await this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), type: 'info' });
        this.statementModalLoaded = true;
        this.$refs.corporateModal.show();
      },
      async loadStatements (params) {
        const result = this.tabType === 'corp'
          ? await storeService.extractByCorporate(this.corporateId, params)
          : await userService.statementUserCreditInfo(this.accountId, params);
        this.statements = [];
        if (result && result.length > 0) {
          this.statements = result[0].elements;
          this.pageInfo = result[0].pageInfo;
          this.totalStatementRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
        let total = 0;
        for await (const statement of this.statements) {
          if (statement.transactionType === 'D') {
            total += statement.mediaLength;
          }
          if (this.tabType === 'user') {
            statement.login = this.accountLogin;
          }
        }
        this.statementTotal = new Date(total * 1000).toISOString().substring(11, 19);
      },
      async updatePage () {
        if (this.statementModalLoaded) {
          await this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage) });
        }
      },
      async updateCorporatePage () {
        if (this.userRadioExtractSelected === 'cnpj' && this.filterUserExtractText.length > 2) {
          await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage), cnpj: this.filterUserExtractText.trim() });
        } else if (this.userRadioExtractSelected === 'cod') {
          await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage), corporateId: this.filterUserExtractText.trim() });
        } else if (this.userRadioExtractSelected === 'name' && this.filterUserExtractText.length > 1) {
          await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage), name: this.filterUserExtractText.trim() });
        } else {
          await this.loadCorporateInfo({ perPage: parseInt(this.perCorporatePage), currentPage: parseInt(this.currentCorporatePage) });
        }
      },
      resetCorporateModal () {
        this.selectedBeginDate = null;
        this.selectedFinalDate = null;
        this.statements = [];
        this.statementModalLoaded = false;
      },
      handleCorporateModalOk (bvModalEvent) {

      },
      onDateChange () {
        if (this.selectedBeginDate && this.selectedFinalDate) {
          this.onStatementSearchClick();
        }
      },
      sortChanged (e) {
        if (this.statementModalLoaded) {
          this.loadStatements({
            perPage: parseInt(this.perStatementPage),
            currentPage: this.currentStatementPage,
            sortBy: e.sortBy,
            sortDesc: e.sortDesc
          });
        }
      },
      onStatementSearchClick () {
        if (this.statementModalLoaded) {
          const date = this.filterCreatedDate();
          if (this.selected === 'user' && this.filterText.length > 2) {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), user: this.filterText.toLowerCase(), date: date });
          } else if (this.selected === 'cod') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), statementId: this.filterText, date: date });
          } else if (this.selected === 'description' && this.filterText.length > 1) {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), observation: this.filterText, date: date });
          } else if (this.selected === 'type') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), transactionType: this.filterText.toUpperCase(), date: date });
          } else if (this.selected === 'duration') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), mediaLength: this.filterText.toLowerCase(), date: date });
          } else if (this.selected === 'api') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), tokenName: this.filterText.toLowerCase(), date: date });
          } else {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), date: date });
          }
        }
      },
      filterCreatedDate () {
        if (this.selectedBeginDate && this.selectedFinalDate) {
          const beginDate = moment(this.selectedBeginDate).unix();
          const finalDate = moment(this.selectedFinalDate).unix();
          return `${beginDate}|${finalDate}`;
        } else {
          return null;
        }
      },
      async generateDataToExport () {
        const date = this.filterCreatedDate();
        const params = {
          perPage: 9999,
          currentPage: 1,
          date: date,
          type: 'exportExtractPJ'
        };
        if (this.selected === 'user' && this.filterText.length > 2) {
          Object.assign(params, { user: this.filterText.toLowerCase() });
        } else if (this.selected === 'cod') {
          Object.assign(params, { statementId: this.filterText });
        } else if (this.selected === 'description' && this.filterText.length > 1) {
          Object.assign(params, { observation: this.filterText });
        } else if (this.selected === 'type') {
          Object.assign(params, { transactionType: this.filterText.toUpperCase() });
        } else if (this.selected === 'duration') {
          Object.assign(params, { mediaLength: this.filterText.toLowerCase() });
        } else if (this.selected === 'api') {
          Object.assign(params, { tokenName: this.filterText.toLowerCase() });
        }
        const result = this.tabType === 'corp'
          ? await storeService.extractByCorporate(this.corporateId, params)
          : await userService.statementUserCreditInfo(this.accountId, params);
        if (this.tabType === 'user') {
          for await (const statement of result[0].elements) {
            statement.login = this.accountLogin;
          }
        }
        if (result && result.length > 0) {
          await this.$refs.csvExporter.export(result[0].elements);
        } else {
          return [];
        }
      }
    }
  };
</script>
